<template>
  <div>
    <b-card class="card--auth" :class="[`step-${step || 0}`]">
      <div class="card__content-wrapper" :style="cardStyle">
        <transition :name="transitionName" mode="out-in">
          <router-view class="child-view"
                       ref="child"
                       @updated="handleViewUpdate"
          ></router-view>
        </transition>
      </div>
    </b-card>
    <p class="copyright mb-3 text-center">香港經濟日報版權所有© {{ nowYear }}</p>
  </div>
</template>

<script>
import { BCard } from 'bootstrap-vue';

export default {
  components: {
    BCard,
  },
  data: () => ({
    transitionName: 'slide-left',
    childHeight: undefined,
    step: 1,
  }),
  computed: {
    cardStyle() {
      if (!this.childHeight) return null;
      return { minHeight: `${this.childHeight}px` };
    },
    nowYear() {
      return new Date().getFullYear();
    },
  },
  beforeRouteUpdate(to, from, next) {
    const toStack = to.meta.stack;
    if (toStack) {
      const fromStack = from.meta.stack;
      if (toStack.type === 'login') {
        this.transitionName = fromStack.index < toStack.index ? 'slide-left' : 'slide-right';
      }
      if (toStack.type === 'signUp') {
        this.transitionName = 'fade';
      }
    } else {
      this.transitionName = undefined;
    }
    next();
  },
  methods: {
    handleViewUpdate() {
      this.step = this.$refs.child.step;
      this.childHeight = this.$refs.child.$el.clientHeight;
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/scss/transition/slide";
@import "../../assets/scss/transition/fade";

.btn-lg {
  padding: 0.875rem 1rem;
  font-size: 1rem;
  line-height: 1.375rem;
  border-radius: 0.3rem;
}
</style>

<style scoped lang="scss">
.card {
  border: none;

  &--auth {
    margin: auto;
    border-radius: 0.5rem;
    box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.2);
    overflow: hidden;
    max-width: 620px;

    @include respond(phone) {
      max-width: 350px;
    }

    &.step-0,
    &.step-4 {
      max-width: 430px;
      margin-top: 28vh;

      @include respond(phone) {
        max-width: 350px;
      }

      .card-body {
        padding: 40px;
      }
    }
  }

  &__content-wrapper {
    transition: min-height 0.2s cubic-bezier(0.55, 0, 0.1, 1);
  }

  &-body {
    padding: 24px;

    @include respond(phone) {
      padding: 18px;
    }
  }
  ::v-deep {
    .mb-3 {
      margin-bottom: 32px !important;
    }

    .mb-5 {
      margin-bottom: 32px !important;
    }
  }
}

.copyright {
  margin-top: 1.25rem;
  color: white;
  font-size: 0.875rem;
  text-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.child-view {
  display: block;
  transition: all 0.2s cubic-bezier(0.55, 0, 0.1, 1);
}
</style>
